module.exports = __webpack_public_path__ + "static/media/montage-excel.930d196c.gif";